import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js';
import './polyfill';

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';

import App from './App';
import store from './store';
import * as serviceWorker from './serviceWorker';

import HeaderSection from './appoinmentApp/header/HeaderSection';
import FooterSection from './appoinmentApp/Footer/FooterSection';
import AdminHeader from './appoinmentApp/admin/AdminHeader';

const layoutStyle = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  backgroundColor: '#ffffff', 
};

const contentStyle = {
  flex: 1,
};

const LayoutWrapper = () => {
  const [isAdminRoute, setIsAdminRoute] = useState(
    window.location.hash.startsWith('#/Admin')
  );

  useEffect(() => {
    const handleHashChange = () => {
      setIsAdminRoute(window.location.hash.startsWith('#/admin'));
    };

    window.addEventListener('hashchange', handleHashChange);
    handleHashChange(); // initial check

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <div style={layoutStyle }>
      {isAdminRoute ? <AdminHeader /> : <HeaderSection />}
      <div style={contentStyle}>
        <App />
      </div>
      {!isAdminRoute && <FooterSection />}
    </div>
  );
};

ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
      <LayoutWrapper />
    </HashRouter>
  </Provider>,
  document.getElementById('root')
);

// ❌ Unregister service worker by default
serviceWorker.unregister();
